import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    window.location.href = 'https://tumomentovital.com/cart/47638720282816:1';
  };
  return <motion.button onClick={handleClick} whileHover={{
    scale: 1.02,
    brightness: 1.1
  }} whileTap={{
    scale: 0.98
  }} animate={{
    boxShadow: ['0px 0px 0px 0px rgba(99, 102, 241, 0)', '0px 0px 20px 5px rgba(99, 102, 241, 0.4)', '0px 0px 0px 0px rgba(99, 102, 241, 0)']
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  }} className={`
        w-full md:max-w-lg mx-auto block
        bg-indigo-500 hover:bg-indigo-400
        text-white font-bold text-lg md:text-xl uppercase tracking-wide
        py-4 px-8 rounded-xl
        shadow-[0_0_15px_rgba(99,102,241,0.5)]
        transition-colors duration-300
        ${className}
      `} data-id="element-15">
      {children}
    </motion.button>;
}